__turbopack_context__.v({
  "active": "ArchitectSection-module__ZccPoa__active",
  "centerInner": "ArchitectSection-module__ZccPoa__centerInner",
  "centerNode": "ArchitectSection-module__ZccPoa__centerNode",
  "centerPulse": "ArchitectSection-module__ZccPoa__centerPulse",
  "content": "ArchitectSection-module__ZccPoa__content",
  "detailDesc": "ArchitectSection-module__ZccPoa__detailDesc",
  "detailTitle": "ArchitectSection-module__ZccPoa__detailTitle",
  "detailsArea": "ArchitectSection-module__ZccPoa__detailsArea",
  "detailsCard": "ArchitectSection-module__ZccPoa__detailsCard",
  "diagramArea": "ArchitectSection-module__ZccPoa__diagramArea",
  "eyebrow": "ArchitectSection-module__ZccPoa__eyebrow",
  "fadeIn": "ArchitectSection-module__ZccPoa__fadeIn",
  "head": "ArchitectSection-module__ZccPoa__head",
  "leftColumn": "ArchitectSection-module__ZccPoa__leftColumn",
  "line": "ArchitectSection-module__ZccPoa__line",
  "node": "ArchitectSection-module__ZccPoa__node",
  "pointsList": "ArchitectSection-module__ZccPoa__pointsList",
  "pointsTitle": "ArchitectSection-module__ZccPoa__pointsTitle",
  "pulse": "ArchitectSection-module__ZccPoa__pulse",
  "rightColumn": "ArchitectSection-module__ZccPoa__rightColumn",
  "section": "ArchitectSection-module__ZccPoa__section",
  "spiderContainer": "ArchitectSection-module__ZccPoa__spiderContainer",
  "subtitle": "ArchitectSection-module__ZccPoa__subtitle",
  "title": "ArchitectSection-module__ZccPoa__title",
});
